import { types, flow, cast } from "mobx-state-tree"
import { dgItemProfileBusiness } from "businesses/dg-item-profile-business"
import { transformObjectKeys } from "utils/app-helper"
import { format } from "date-fns"

const DGItemProfileStore = types
  .model({
    data: types.optional(types.frozen(), []),
    detailInfo: types.maybeNull(types.frozen()),
    isLoading: types.maybeNull(types.boolean),
    customFilters: types.maybeNull(types.frozen()),
    selectedId: types.maybeNull(types.string, ""),
    searchText: types.maybeNull(types.string, ""),
    forceReload: types.maybeNull(types.boolean, false),
  })
  .views(self => ({
    get filters() {
      const res = {}
      if (self.customFilters) {
        const dateItems = ["before_date", "after_date"]
        const boolItems = ["active", "id8000", "marine_pollutant", "personal_care", "lithium_battery"]
        for (const prop in self.customFilters) {
          const val = self.customFilters[prop]
          if (val) {
            if (dateItems.includes(prop)) {
              res[prop] = format(val, "yyyy-MM-dd")
            } else if (boolItems.includes(prop)) {
              res[prop] = val ? "Y" : "N"
            } else {
              res[prop] = val
            }
          }
        }
      }

      return res
    },
  }))
  .actions(self => ({
    setForceReload() {
      self.forceReload = !self.forceReload
    },
    setData(data) {
      self.data = data
    },
    setSelectedId(id) {
      self.selectedId = id
    },
    setSearchText(val) {
      self.searchText = val
    },
    setCustomFilters(data) {
      self.customFilters = cast(data)
    },
  }))
  .actions(self => ({
    resetData() {
      self.detailInfo = null
      self.selectedId = ""
    },
    loadData: flow(function* (showLoading = true) {
      if (!self.searchText) {
        self.setData([])
        return
      }

      if (showLoading) self.isLoading = true
      const searchParams = {
        ...(self.filters || {}),
      }
      const data = yield dgItemProfileBusiness.getData(searchParams)
      self.setData(data)
      if (showLoading) self.isLoading = false
    }),
    loadDetailData: flow(function* (id) {
      self.selectedId = id

      self.isLoading = true
      const info = yield dgItemProfileBusiness.getDetailData(id)
      if (info?.MSDS_EXPIRY_DATE) info.MSDS_EXPIRY_DATE = new Date(info.MSDS_EXPIRY_DATE)
      if (info?.MSDS_CREATION_DATE) info.MSDS_CREATION_DATE = new Date(info.MSDS_CREATION_DATE)
      self.detailInfo = info
      self.isLoading = false
    }),
    addOrUpdateData: flow(function* (data) {
      const result = self.selectedId ? yield dgItemProfileBusiness.updateData(data) : yield dgItemProfileBusiness.addData(data)
      return result ? transformObjectKeys(result, true) : result
    }),
    deleteData: flow(function* () {
      self.isLoading = true
      const params = {
        ID: self.selectedId,
      }
      const result = yield dgItemProfileBusiness.deleteData(params)
      self.isLoading = false

      return result?.STATUS_CODE === 200
    }),
  }))
export default DGItemProfileStore
